import { cloneDeep } from 'lodash';
import { clone, unit as mathjsUnit } from 'mathjs';
import Cookies from 'js-cookie';
import Definition from '@client/config/definition';
import { isNoValue, paceSKmToOther, paceToSKm } from '@client/helper';
import { initStore as useAppStore } from '@client/store/initStore';
import { s2ms, s2hmsFullStr } from '@client/helper/day';
import { speedToKmh, speedKmhToOther } from '@client/helper/speed';
import { distanceM2Km, distanceMToOther, distanceToM } from '@client/helper/distance';
import { weightGToOther, weightToG } from '@client/helper/weight';
import { i18n } from '@client/helper';
import * as corosSportConfig from '@coros/sport-config';
const { isIndoorClimbOrBoulderingTrainingSportType } = corosSportConfig.sport.climb;
const { t } = i18n;
function getHrTypeByHrName(hrName) {
  // 1：使用最大心率类型，2：使用储备心率类型，3: 乳酸阈心率类型
  const nameMaps = {
    maxHr: 1,
    rhr: 2,
    lthr: 3
  };
  return nameMaps[hrName] || 0;
}

function getZoneFromOptions(options, zoneType) {
  let range = [];
  let ratioRange = [];
  let fistZone = null;
  let zone = null;

  const findIt = (list) => {
    if (zone) {
      return;
    }

    list.forEach((item) => {
      if (item.children) {
        findIt(item.children);
        return;
      }

      if (!fistZone && item.type) {
        fistZone = item;
      }

      if (item.type === zoneType) {
        zone = item;
      }
    });
  };

  findIt(options);

  if (zoneType && zone) {
    range = [Math.round(zone.range[0]), Math.round(zone.range[1])];
    ratioRange = [Math.round(zone.ratioRange[0]), Math.round(zone.ratioRange[1])];
  } else {
    range = [Math.round(fistZone.range[0]), Math.round(fistZone.range[1])];
    ratioRange = [Math.round(fistZone.ratioRange[0]), Math.round(fistZone.ratioRange[1])];
  }

  return {
    range,
    ratioRange
  };
}

export function getExerciseByTypeFromDefinition(exerciseDefinition, exerciseType) {
  let exercise = {};

  for (let n = 0, length = exerciseDefinition.length; n < length; n++) {
    const item = exerciseDefinition[n];
    if (item.exerciseType === exerciseType) {
      exercise = cloneDeep(item);
      break;
    }
  }
  return exercise;
}

function getIntensityName(options = {}, sportConfig) {
  const typeConfig = sportConfig.train.intensity.typeConfig;
  let result = '';
  if (['heart'].includes(options.typeName)) {
    // 旧数据没有hrType的，都当做是储备心率
    options.hrTypeName = options.hrTypeName || 'rhr';
    for (const n in typeConfig) {
      if (
        typeConfig[n].type === options.typeName &&
        typeConfig[n].hrType === options.hrTypeName &&
        !!typeConfig[n].isIntensityPercent === !!options.isIntensityPercent
      ) {
        result = n;
        break;
      }
    }
  } else if (['pace', 'adjustedPace'].includes(options.typeName)) {
    for (const n in typeConfig) {
      if (typeConfig[n].type === options.typeName && !!typeConfig[n].isIntensityPercent === !!options.isIntensityPercent) {
        result = n;
        break;
      }
    }
  } else {
    for (const n in typeConfig) {
      if (typeConfig[n].type === options.typeName) {
        result = n;
        break;
      }
    }
  }

  return `${result}`;
}

function getDefaultValue(mapConfig) {
  const result = {};
  if (!mapConfig) {
    return result;
  }

  for (const key in mapConfig.typeConfig) {
    result[key] = getDefaultValeFromUnitConfig(mapConfig.typeConfig[key]);
  }

  return cloneDeep(result);
}
// 从单个单位的配置中获取默认的值
function getDefaultValeFromUnitConfig(conf, unit) {
  unit = unit || conf.defaultUnit;
  const defaultValues = {
    type: '',
    value: '',
    ratioRange: [],
    range: [],
    unit: `${unit || ''}`
    // rangeText: []
  };
  // 无参数的为没有输入元素的选项
  if (['', undefined, null].includes(unit)) {
    return cloneDeep(defaultValues);
  }

  const unitConfig = conf.unitConfig[unit];

  if (!unitConfig) {
    return cloneDeep(defaultValues);
  }
  const inputConfig = unitConfig.inputConfig;
  if (inputConfig) {
    defaultValues.value = inputConfig.defaultValue;
  }

  const ratioRangeConfig = unitConfig.ratioRangeConfig;
  if (ratioRangeConfig) {
    defaultValues.ratioRange = ratioRangeConfig.defaultValue;
  }

  const rangeConfig = unitConfig.rangeConfig;
  if (rangeConfig) {
    defaultValues.range = rangeConfig.defaultValue;
  }

  const typeConfig = unitConfig.typeConfig;

  if (typeConfig) {
    defaultValues.type = typeConfig.defaultValue;
    if (defaultValues.type > 0) {
      typeConfig.options.forEach((item) => {
        if (item.type === defaultValues.type) {
          defaultValues.range = cloneDeep(item.range);
          defaultValues.ratioRange = cloneDeep(item.ratioRange);
        }
      });
    }
  }
  // defaultValues.rangeText = [];

  return cloneDeep(defaultValues);
}

// 计算储备心率的区间值
function countRHr(restHr, maxHr, ratio) {
  return (maxHr - restHr) * (ratio / 100) + restHr;
}

// 计算储备心率的区间百分比值
function countRHrRatio(restHr, maxHr, hr) {
  return ((hr - restHr) / (maxHr - restHr)) * 100;
}

function getHrNameByHrType(hrType) {
  // 1：使用最大心率类型，2：使用储备心率类型，3: 乳酸阈心率类型
  const nameMaps = {
    1: 'maxHr',
    2: 'rhr',
    3: 'lthr'
  };
  return nameMaps[hrType] || '';
}

function getIntensityZoneByType(options = {}, sportConfig) {
  const exerciseTypeName = options.exerciseTypeName;
  const intensityTypeName = options.intensityTypeName;
  const zoneType = options.zoneType;

  const typeConfig = sportConfig[exerciseTypeName].intensity.typeConfig[intensityTypeName];
  const unit = options.unit || typeConfig.defaultUnit;
  const list = typeConfig.unitConfig[unit]?.typeConfig?.options || [];
  let result = null;
  list.forEach((item) => {
    if (item.type === zoneType) {
      result = item;
    }
  });

  return cloneDeep(result);
}

export function generateExerciseUniqueId() {
  const randomNum = new Date().getTime();
  const randomStr = Math.random().toString(36).slice(-4);
  return `${randomNum}${randomStr}`;
}

function getDefaultExercise(exerciseData, sportConfig) {
  const exerciseTypeName = Definition.exerciseTypeName[exerciseData.exerciseType];
  const sportExerciseConfigure = sportConfig[exerciseTypeName];
  const targetConfig = sportExerciseConfigure.target;
  const intensityConfig = sportExerciseConfigure.intensity;
  const restConfig = sportExerciseConfigure.rest;

  const basic = {
    sportType: exerciseData.sportType,
    // exercise类型
    exerciseTypeName,
    name: exerciseData.name,
    originId: exerciseData.originId || exerciseData.id,
    targetTypeName: 'notSet',
    targetCount: {},
    // 训练强度：
    isIntensityPercent: exerciseData.isIntensityPercent || false,
    intensityTypeName: 'notSet',
    intensityCount: {},
    // 休息类型, 0-手动结束，1-休息时间，2-心率恢复
    restTypeName: 'noRest',
    restCount: {},
    sets: exerciseData.sets || 1
  };

  basic.targetCount = getDefaultValue(targetConfig);
  basic.intensityCount = getDefaultValue(intensityConfig);
  basic.restCount = getDefaultValue(restConfig);
  // 心率、配速区间的百分比、具体值需要四舍五入
  const intensityKeys = ['%maxHr', '%rhr', '%lthr', '%thresholdPace'];
  intensityKeys.forEach((key) => {
    if (Reflect.has(basic.intensityCount, key)) {
      const intensityCount = basic.intensityCount[key];
      if (intensityCount.ratioRange.length === 2) {
        intensityCount.ratioRange[0] = Math.round(intensityCount.ratioRange[0]);
        intensityCount.ratioRange[1] = Math.round(intensityCount.ratioRange[1]);
      }

      if (intensityCount.range.length === 2) {
        intensityCount.range[0] = Math.round(intensityCount.range[0]);
        intensityCount.range[1] = Math.round(intensityCount.range[1]);
      }
    }
  });
  // const intensityPaceKeys = ['adjustedPace', 'thresholdPace'];
  // intensityPaceKeys.forEach((key) => {
  //   if (Reflect.has(basic.intensityCount, key)) {
  //     const intensityCount = basic.intensityCount[key];
  //     // 转为配速分分秒
  //     const [value0, value1] = intensityCount.range;
  //     const text0 = s2ms(value0); //`10'20"`;
  //     const text1 = s2ms(value1);
  //     intensityCount.rangeText = [text0, text1];
  //   }
  // });
  return basic;
}
const store = useAppStore();
/**
 * 将接口返回的动作数据转换为组件需要的数据格式
 * @param baseData
 * @param exerciseData
 * @param convert 当为false时，忽略公英制转换，直接使用数值作为该单位制下的值
 * @param unit
 */
export const dealExerciseData = (
  baseData,
  exerciseData,
  sportConfig,
  criticalPower,
  zoneData,
  convert,
  {
    climbConfig,
    globalGradeSystemVal,
    isAddingNew,
    isChangingExerciseType,
    poolLengthUnit,
    customPoolLength,
    // 泳池长度id
    poolLengthId,
    // 泳池长度单位是否是英制 yard=4
    swimPoolIsYard,
    distanceOptions
  } = {}
) => {
  const sportName = Definition.sportCategoryName[exerciseData.sportType];
  /* 做数据兼容 begin */
  (() => {
    const intensityType = Definition.intensityTypeName[exerciseData.intensityType];

    if (intensityType === 'heart') {
      if (exerciseData.intensityCustom || exerciseData.isIntensityPercent) {
        // 有区间或者是百分比的，统一走百分比
        exerciseData.isIntensityPercent = true;
      } else {
        // 没有区间又不是百分比的，走绝对值
        exerciseData.hrType = 2;
        exerciseData.intensityCustom = 0;
      }
    } else if (['pace', 'adjustedPace'].includes(intensityType)) {
      if (exerciseData.intensityCustom || exerciseData.isIntensityPercent) {
        // 有区间或者是百分比的，统一走百分比
        exerciseData.isIntensityPercent = true;
      } else {
        // 没有区间又不是百分比的，走绝对值
        exerciseData.intensityCustom = 0;
      }
    }

    // 泳池前置特殊处理
    if (sportName === 'swim') {
      // exerciseType = 3 恢复，泳姿默认为0
      if (exerciseData.exerciseType === 3) {
        exerciseData.intensityValue = 0;
      }
      // exerciseData.exerciseType=5 代替了 exerciseType=2 && subType=1 的类型
      if (exerciseData.exerciseType === 2 && exerciseData.subType === 1) {
        exerciseData.exerciseType = 5;
      }

      // 旧数据的所有动作都根据 swimPoolIsYard 来转换到 yd=4 或者 m=2
      if (typeof poolLengthId === 'undefined') {
        const TARGET_UNIT_TYPE = corosSportConfig.basic.TARGET_UNIT_TYPE;
        // console.log(`exerciseData.targetType`, exerciseData.targetDisplayUnit, exerciseData.targetValue, poolLengthId, swimPoolIsYard);
        if (exerciseData.targetType === 5) {
          exerciseData.targetDisplayUnit = swimPoolIsYard ? TARGET_UNIT_TYPE.YD : TARGET_UNIT_TYPE.M;
        }
      }
    }
  })();
  /* 做数据兼容 end */

  const token = Cookies.get(store.tokenName);
  const result = Object.assign({}, getDefaultExercise(exerciseData, sportConfig), cloneDeep(baseData));
  const exerciseTypeConfig = sportConfig[result.exerciseTypeName];

  // 目标相关
  if (Object.keys(exerciseTypeConfig?.target?.typeConfig || {}).length > 0) {
    const targetTypeName = Definition.targetTypeName[exerciseData.targetType];

    const targetTypeCount = result.targetCount[targetTypeName];
    const targetTypeConfig = exerciseTypeConfig?.target?.typeConfig?.[targetTypeName];
    // 将目标单位类型转化为对应的名称
    let targetDisplayUnitName = Definition.getTargetUnitNameByType(exerciseData.targetDisplayUnit);
    let targetValue = exerciseData.targetValue;
    result.targetTypeName = targetTypeName;
    if (!targetTypeConfig) return null;
    /* 做数据兼容，兼容一些单位字段不应该有值却带了值的数据 */
    if (!targetDisplayUnitName || !targetTypeConfig?.unitConfig?.[targetDisplayUnitName]) {
      targetDisplayUnitName = targetTypeConfig.defaultUnit;
    }

    /* 做数据兼容，兼容一些单位字段不应该有值却带了值的数据 end */

    targetTypeCount.unit = targetDisplayUnitName;

    if (targetTypeName === 'distance') {
      (() => {
        const multiplier = 100;
        targetValue = targetValue / multiplier;
        if (!convert) {
          targetTypeCount.value = Number(distanceM2Km(targetValue, 2));
          return;
        }

        // 根据单位，对原始数据进行单位换算
        targetTypeCount.value = Number(distanceMToOther(targetTypeCount.unit, targetValue));
      })();
    } else if (targetTypeName === 'cumulativeClimb') {
      targetTypeCount.value = Number(mathjsUnit(targetValue, 'cm').toNumber(targetTypeCount.unit).toFixed(0));
    } else {
      if (targetTypeName === 'time') {
        targetTypeCount.valueText = s2hmsFullStr(targetValue);
      }
      targetTypeCount.value = targetValue;
    }
  } else {
    result.targetTypeName = 'notSet';
  }

  // 强度相关
  if (Object.keys(exerciseTypeConfig?.intensity?.typeConfig || {}).length > 0) {
    const intensityTypeName = getIntensityName(
      {
        typeName: Definition.intensityTypeName[exerciseData.intensityType],
        hrTypeName: getHrNameByHrType(exerciseData.hrType),
        isIntensityPercent: exerciseData.isIntensityPercent
      },
      sportConfig
    );
    const intensityTypeConfig = sportConfig[result.exerciseTypeName].intensity.typeConfig[intensityTypeName];
    // 将目标单位类型转化为对应的名称
    let intensityDisplayUnitName = Definition.getIntensityUnitNameByType(exerciseData.intensityDisplayUnit);

    /* 做数据兼容，兼容一些单位字段不应该有值却带了值的数据 begin */
    if (!intensityDisplayUnitName || !intensityTypeConfig?.unitConfig?.[intensityDisplayUnitName]) {
      intensityDisplayUnitName = intensityTypeConfig.defaultUnit;
    }
    /* 做数据兼容，兼容一些单位字段不应该有值却带了值的数据 end */

    const intensityValue = exerciseData.intensityValue;
    const intensityRangeKey = 'range';
    const intensityRatioRangeKey = 'ratioRange';
    const intensityRangeTextKey = 'rangeText';

    result.intensityTypeName = intensityTypeName;
    // 百分比区间值
    if (!isNoValue(exerciseData.intensityPercent)) {
      exerciseData.intensityPercent = exerciseData.intensityPercent / 1000;
    }
    if (!isNoValue(exerciseData.intensityPercentExtend)) {
      exerciseData.intensityPercentExtend = exerciseData.intensityPercentExtend / 1000;
    }
    const intensityCount = result.intensityCount[intensityTypeName];
    const intensityRate = intensityCount[intensityRangeKey];
    const intensityRatioRate = intensityCount[intensityRatioRangeKey];
    const intensityRangeText = intensityCount[intensityRangeTextKey];

    if (intensityDisplayUnitName) {
      intensityCount.unit = intensityDisplayUnitName;
    }
    if (intensityTypeConfig.type === 'notSet') {
    } else if (intensityTypeConfig.type === 'weight') {
      (() => {
        intensityCount.type = exerciseData.intensityCustom || 0;

        if (!intensityCount.type) {
          intensityCount.value = (intensityValue || 0) / 1000;

          if (!convert) {
            return;
          }

          intensityCount.value = weightGToOther(intensityCount.unit, intensityValue, 1);
        }
      })();
    } else if (intensityTypeConfig.type === 'heart') {
      (() => {
        let leftValue = exerciseData.intensityValue;
        let rightValue = exerciseData.intensityValueExtend;
        let leftPercent = exerciseData.intensityPercent;
        let rightPercent = exerciseData.intensityPercentExtend;

        // 兼容旧数据没有选中心率类型
        const hrType = [undefined, null, '', 0, '0'].includes(exerciseData.hrType) ? 2 : Number(exerciseData.hrType);
        // 选择的是什么区间
        let type = exerciseData.intensityCustom;

        type = isNoValue(type) ? 0 : Number(type);

        const hrTypeName = getHrNameByHrType(hrType);
        if (!hrTypeName) {
          throw new Error('no this hr type');
        }

        // 获取区间列表
        const zone = getIntensityZoneByType(
          {
            exerciseTypeName: result.exerciseTypeName,
            intensityTypeName,
            zoneType: type,
            unit: 'default'
          },
          sportConfig
        );

        /**
         * 新的逻辑start
         */
        if (token) {
          // 已登录
          if (type) {
            // 有区间选项
            leftPercent = zone.ratioRange[0];
            rightPercent = zone.ratioRange[1];
            leftValue = zone.range[0];
            rightValue = zone.range[1];
          } else {
            // 自定义
            if (exerciseData.isIntensityPercent) {
              // 以百分比为准
              if (hrTypeName === 'rhr') {
                leftValue = countRHr(zoneData.rhr, zoneData.maxHr, leftPercent);

                rightValue = countRHr(zoneData.rhr, zoneData.maxHr, rightPercent);
              } else {
                leftValue = (leftPercent / 100) * zoneData[hrTypeName];
                rightValue = (rightPercent / 100) * zoneData[hrTypeName];
              }
            } else {
              // 以数值为准
              leftPercent = (leftValue / zoneData[hrTypeName]) * 100;
              rightPercent = (rightValue / zoneData[hrTypeName]) * 100;

              // rhr心率类型
              if (hrTypeName === 'rhr') {
                leftPercent = countRHrRatio(zoneData.rhr, zoneData.maxHr, leftValue);
                rightPercent = countRHrRatio(zoneData.rhr, zoneData.maxHr, rightValue);
              }
            }
          }
        } else {
          // 未登录
          if (type) {
            // 有区间选项
            leftPercent = zone.ratioRange[0];
            rightPercent = zone.ratioRange[1];
            leftValue = zone.range[0];
            rightValue = zone.range[1];
          } else {
            // 自定义
          }
        }

        intensityRatioRate[0] = Math.round(leftPercent);
        intensityRatioRate[1] = Math.round(rightPercent);
        intensityRate[0] = Math.round(leftValue);
        intensityRate[1] = Math.round(rightValue);
        /**
         * 新的逻辑end
         */
        intensityCount.hrType = hrType;
        intensityCount.type = type;
      })();
    } else if (['pace', 'adjustedPace'].includes(intensityTypeConfig.type)) {
      (() => {
        let type = exerciseData.intensityCustom;
        type = [undefined, null, ''].includes(type) ? 0 : Number(type);
        type = type === 4 ? 3 : type;

        let zone;
        if (!['thresholdPace', 'adjustedPace'].includes(intensityTypeName)) {
          // 获取区间列表
          const zoneList = intensityTypeConfig.unitConfig[intensityCount.unit].typeConfig?.options;
          // 获取出所选区间
          const zoneObj = {};
          zoneList.forEach((item) => {
            zoneObj[item.type] = item;
          });
          zone = zoneObj[type];
        }

        intensityCount.type = type;

        const multiplier = exerciseData.intensityMultiplier || 1;

        let leftValue = exerciseData.intensityValue / multiplier;
        let rightValue = exerciseData.intensityValueExtend / multiplier;
        let leftPercent = exerciseData.intensityPercent;
        let rightPercent = exerciseData.intensityPercentExtend;
        let leftRangeText;
        let rightRangeText;

        let ltsp = zoneData.ltsp;
        /**
         * 新的逻辑start
         */

        if (token) {
          // 已登录
          if (type) {
            // 有区间选项
            leftPercent = zone.ratioRange[0];
            rightPercent = zone.ratioRange[1];
            leftValue = zone.range[0];
            rightValue = zone.range[1];
          } else {
            // 自定义
            if (exerciseData.isIntensityPercent) {
              // 以百分比为准
              leftValue = (ltsp / leftPercent) * 100;
              rightValue = (ltsp / rightPercent) * 100;
            } else {
              // 以数值为准
              leftPercent = (ltsp / leftValue) * 100;
              rightPercent = (ltsp / rightValue) * 100;
            }
          }
        } else {
          // 未登录
          if (type) {
            // 有区间选项
            leftPercent = zone.ratioRange[0];
            rightPercent = zone.ratioRange[1];
            leftValue = zone.range[0];
            rightValue = zone.range[1];
          } else {
            // 自定义
          }
        }

        // 根据单位，对原始数据进行单位换算
        if (!type) {
          ltsp = paceSKmToOther(intensityCount.unit, ltsp, 6);
          leftValue = paceSKmToOther(intensityCount.unit, leftValue, 6);
          rightValue = paceSKmToOther(intensityCount.unit, rightValue, 6);
        }

        intensityRatioRate[0] = Math.round(leftPercent);
        intensityRatioRate[1] = Math.round(rightPercent);
        intensityRate[0] = Math.round(leftValue);
        intensityRate[1] = Math.round(rightValue);

        /**
         * 新的逻辑end
         */
      })();
    } else if (intensityTypeConfig.type === 'speed') {
      (() => {
        const multiplier = 100;
        const leftValue = exerciseData.intensityValue;
        const rightValue = exerciseData.intensityValueExtend;

        if (!convert) {
          // 不转换
          intensityRate[0] = leftValue / multiplier;
          intensityRate[1] = rightValue / multiplier;
        } else {
          // 根据单位，对原始数据进行单位换算
          intensityRate[0] = speedKmhToOther(intensityCount.unit, leftValue / multiplier, 1);
          intensityRate[1] = speedKmhToOther(intensityCount.unit, rightValue / multiplier, 1);
        }
        intensityRate[0] = Number(intensityRate[0]);
        intensityRate[1] = Number(intensityRate[1]);
      })();
    } else if (intensityTypeConfig.type === 'swimmingStyle') {
      intensityCount.type = exerciseData.intensityValue;
    } else if (intensityTypeConfig.type === 'ftp') {
      let leftValue = exerciseData.intensityValue;
      let rightValue = exerciseData.intensityValueExtend;
      let leftPercent = exerciseData.intensityPercent;
      let rightPercent = exerciseData.intensityPercentExtend;
      // 选择的是什么区间
      let type = exerciseData.intensityCustom;
      intensityCount.type = type || 0;
      // 获取区间列表
      const zone = getIntensityZoneByType(
        {
          exerciseTypeName: result.exerciseTypeName,
          intensityTypeName,
          zoneType: type,
          unit: 'default'
        },
        sportConfig
      );
      if (token) {
        // 已登录
        if (type) {
          // 有区间选项
          leftPercent = zone.ratioRange[0];
          rightPercent = zone.ratioRange[1];
          leftValue = zone.range[0];
          rightValue = zone.range[1];
        } else {
          leftValue = (leftPercent / 100) * zoneData.ftp;
          rightValue = (rightPercent / 100) * zoneData.ftp;
        }
      } else {
        // 未登录
        if (type) {
          // 有区间选项
          leftPercent = zone.ratioRange[0];
          rightPercent = zone.ratioRange[1];
          leftValue = zone.range[0];
          rightValue = zone.range[1];
        } else {
          // 自定义
        }
      }

      intensityRatioRate[0] = Math.round(leftPercent);
      intensityRatioRate[1] = Math.round(rightPercent);
      intensityRate[0] = Math.round(leftValue);
      intensityRate[1] = Math.round(rightValue);
    } else if (intensityTypeConfig.type === 'power') {
      (() => {
        // intensityCount.unit = 'default';
        let type = exerciseData.intensityCustom;
        type = isNoValue(type) ? 0 : Number(type);

        const leftValue = exerciseData.intensityValue;
        const rightValue = exerciseData.intensityValueExtend;

        intensityCount.type = type;

        const multiplier = 1;

        if (type === 0) {
          // 自定义
          if (!isNoValue(leftValue)) {
            intensityRate[0] = leftValue / multiplier;
          }
          if (!isNoValue(rightValue)) {
            intensityRate[1] = rightValue / multiplier;
          }
        } else {
          // 非自定义
          // 获取出所选区间
          const zone = getIntensityZoneByType(
            {
              exerciseTypeName: result.exerciseTypeName,
              intensityTypeName,
              zoneType: intensityCount.type,
              unit: intensityCount.unit
            },
            sportConfig
          );
          // if (!zone) {
          //   throw new Error('no power zone')
          // }

          if (token) {
            // 已登录
            // 2024年2月，骑行类型下功率不再使用下拉选项
            if (criticalPower && zone && exerciseData.sportType !== 2) {
              // 有CP值
              // rate的左右值需要转化为本人区间对应的值
              intensityCount.type = type;

              intensityRate[0] = zone.range[0];
              intensityRate[1] = zone.range[1];
              return;
            } else {
              // 无CP值
              // 将类型转化为自定义
              // 区间对应的左右值作为自定义的左右值
              intensityCount.type = 0;
            }
          } else {
            // 未登录
            intensityCount.type = 0;
            // intensityCount.type = type || 0
          }

          if (!isNoValue(leftValue)) {
            intensityRate[0] = leftValue / multiplier;
          }
          if (!isNoValue(rightValue)) {
            intensityRate[1] = rightValue / multiplier;
          }
        }
      })();
    } else if (intensityTypeConfig.type === 'cadence') {
      (() => {
        const leftValue = exerciseData.intensityValue;
        const rightValue = exerciseData.intensityValueExtend;
        const multiplier = 1;

        intensityRate[0] = leftValue / multiplier;
        intensityRate[1] = rightValue / multiplier;
      })();
    } else if (intensityTypeConfig.type === 'gradeSystem') {
      // 新建
      // 动作保存为“不设置”exerciseData.gradeSystem 是 0，这里要区分开
      if (!exerciseData.gradeSystem && exerciseData.gradeSystem !== 0) {
        const userGradeConf = climbConfig.find((i) => i.sportType === exerciseData.sportType);
        intensityCount.type =
          globalGradeSystemVal && 'custom' !== globalGradeSystemVal ? globalGradeSystemVal : userGradeConf.gradingSystem;
        exerciseData.onsightGradeOffset = exerciseData.onsightGradeOffset || 32;
      } else {
        intensityCount.type = exerciseData.gradeSystem;
      }
      // 视攀等级偏移，填32+视攀+/-数，如难度等级为视攀-8则value=32+(-8)=24
      if (exerciseData.onsightGradeOffset !== 0) {
        intensityCount.hardLevelValue = '1-' + exerciseData.onsightGradeOffset;
      }
      // 为0时表示选的是难度等级
      else {
        intensityCount.hardLevelValue = '2-' + exerciseData.intensityValue;
      }
    }
  } else {
    result.intensityTypeName = 'notSet';
  }

  // 休息相关
  if (Object.keys(exerciseTypeConfig?.rest?.typeConfig || {}).length > 0) {
    const restTypeName = Definition.restTypeName[exerciseData.restType];
    const restCount = result.restCount[restTypeName];
    if (['strength'].includes(sportName)) {
      if (restTypeName === 'time') {
        // 目标类型为时间，需要转化为Date对象
        restCount.value = exerciseData.restValue;
      }
      result.restTypeName = restTypeName;
    } else {
      result.restTypeName = 'noRest';
    }
  } else {
    result.restTypeName = 'noRest';
  }

  // 泳池后置特殊处理，设置包干时间、距离单位
  if (sportName === 'swim') {
    // 包干时间 , exerciseType=5 表示包干训练
    result.packageTime = exerciseData.exerciseType === 5 ? exerciseData.packageTime || 2 * 60 : 0;
    // 距离单位, 2 m 是默认值
    if ((isAddingNew || isChangingExerciseType) && poolLengthUnit) {
      const unitName = corosSportConfig.basic.getTargetUnitNameByType(poolLengthUnit);
      result.targetCount.distance.unit = unitName;
      result.targetCount.distance.value = distanceOptions?.[0]?.value || customPoolLength || 100;
    }
    // 旧数据的值处理，要求是泳池长度 25m 或者 25yard 的倍数
    if (!isAddingNew && typeof poolLengthId === 'undefined') {
      result.targetCount.distance.value = corosSportConfig.sport.poolSwim.convertOldDistanceValue(result.targetCount.distance.value);
    }
  }

  result.originExercise = cloneDeep(exerciseData);
  return result;
};

// 将接口返回的动作数据，转换为前端组件使用的格式
// 训练组合使用，增加了一些训练组合需要用到的字段
export const toComponentExercises = (exercise, exerciseDefinition, sportConfig, criticalPower, zoneData, convert = true, extraConfig) => {
  const trainExercise = getExerciseByTypeFromDefinition(exerciseDefinition, Definition.getExerciseTypeInfoByName('train').value);
  const exerciseData = cloneDeep(exercise || trainExercise);

  const result = {
    name: exerciseData.name,
    sets: exerciseData.sets || 1,
    exerciseType: exerciseData.exerciseType,
    // 仅用于前端的动作唯一id
    exerciseUniqueId: generateExerciseUniqueId()
  };

  if (exercise) {
    if ([0, '0'].includes(exercise.originId) && trainExercise) {
      result.originId = trainExercise.id;
    }

    if (!exercise.name && exercise.exerciseType) {
      result.name = t(Definition.getExerciseNameByType(exercise.exerciseType).i18n);
    }
  }
  const data = dealExerciseData(result, exerciseData, sportConfig, criticalPower, zoneData, convert, extraConfig);
  if (!data) return null;
  return data;
};

// 将没有分组嵌套格式的数据转化为前端的分组嵌套数据格式
export const toGroupTypeExercises = (data, exerciseDefinition, sportConfig, criticalPower, zoneData, convert = true, extraConfig) => {
  const result = [];
  const groupIndex = {};
  const exercises = cloneDeep(data);
  exercises.forEach((item, index) => {
    if (item.isGroup) {
      result.push({
        groupId: item.id,
        exerciseList: [],
        sets: item.sets,
        originExercise: item
      });
      groupIndex[item.id] = result.length - 1;
      return;
    }
    if (['', 0, '0', undefined, null].includes(item.groupId)) {
      const exercise = toComponentExercises(item, exerciseDefinition, sportConfig, criticalPower, zoneData, convert, extraConfig);
      if (exercise) {
        result.push(exercise);
      }

      return;
    }
    const exercise = toComponentExercises(item, exerciseDefinition, sportConfig, criticalPower, zoneData, convert, extraConfig);
    if (exercise) {
      result[groupIndex[item.groupId]].exerciseList.push(exercise);
    }
  });
  return result;
};

export const getGlobalIntensityTypeName = (info = {}, sportConfig) => {
  const exercises = info.exercises || [];
  let result = 'custom';
  let lastIntensityTypeName = null;

  const checkList = (list = []) => {
    let same = true;

    for (const item of list) {
      if (item.exerciseList) {
        if (!checkList(item.exerciseList)) {
          same = false;
          break;
        }
        continue;
      }
      item.intensityTypeName = item.intensityTypeName || '';

      if (['notSet'].includes(item.intensityTypeName)) {
        continue;
      }

      if (!lastIntensityTypeName) {
        lastIntensityTypeName = item.intensityTypeName;
        continue;
      }

      if (item.intensityTypeName !== lastIntensityTypeName) {
        same = false;
        break;
      }
    }

    return same;
  };

  // 遍历动作，确定全局强度类型
  if (checkList(exercises)) {
    result = lastIntensityTypeName;
  } else {
    result = 'custom';
  }
  if (!lastIntensityTypeName) {
    result = 'custom';
  }

  // 如果已经设置过全局的强度类型，读取
  if (result !== 'custom' && info?.referExercise && Reflect.has(info.referExercise, 'valueType')) {
    // 是新的强度类型
    const referExercise = info.referExercise;
    const intensityTypeName = Definition.intensityTypeName[referExercise?.intensityType];
    const hrTypeName = getHrNameByHrType(referExercise?.hrType);

    const globalResult = getIntensityName(
      {
        typeName: intensityTypeName,
        hrTypeName,
        isIntensityPercent: {
          1: false,
          2: true
        }[referExercise.valueType]
      },
      sportConfig
    );

    if (['notSet', ''].includes(globalResult) || globalResult !== result) {
      result = 'custom';
    }
  }

  return result;
};

export const changeIntensity = (exercise, typeName, sportConfig) => {
  const result = cloneDeep(exercise);
  const typeConfig = sportConfig.train.intensity.typeConfig[typeName];

  result.intensityTypeName = typeName;
  result.isIntensityPercent = typeConfig.isIntensityPercent || false;

  if (Reflect.has(typeConfig, 'defaultIntensityCustom')) {
    result.intensityCount[typeName].type = typeConfig.defaultIntensityCustom;

    // 根据区间类型获取对应的范围值
    const options = typeConfig.unitConfig?.[result.intensityCount[typeName].unit]?.typeConfig?.options || [];
    // 部分强度类型没有区间 options 比如 rhr
    if (options.length) {
      const rangeInfo = getZoneFromOptions(options, typeConfig.defaultIntensityCustom);
      result.intensityCount[typeName].range = rangeInfo.range;
      result.intensityCount[typeName].ratioRange = rangeInfo.ratioRange;
    }
  }

  return result;
};

export const getNewInfoAfterChangeFastIntensityType = (info, typeName, sportConfig, unified = true) => {
  const result = cloneDeep(info);
  result.fastIntensityTypeName = typeName;
  if (typeName === 'custom') {
    return result;
  }

  const parseExercise = (exercise) => {
    // 是否需要统一动作的快速强度类型
    if (unified) {
      exercise = changeIntensity(exercise, typeName, sportConfig);
    }
    return exercise;
  };

  result.exercises = result.exercises.map((exercise) => {
    // 分组
    if (exercise.groupId) {
      exercise.exerciseList = exercise.exerciseList.map((item) => {
        return parseExercise(item);
      });
    } else {
      // 单项
      exercise = parseExercise(exercise);
    }
    return exercise;
  });

  return result;
};

export const getExerciseNum = (exercises) => {
  let exerciseLength = 0;

  exercises.forEach((listItem) => {
    if (!listItem.groupId) {
      exerciseLength++;
      return;
    }
    listItem.exerciseList.forEach((item) => {
      exerciseLength++;
    });
  });

  return exerciseLength;
};

const getExerciseByIdFromDefinition = (exerciseId, exerciseDefinition) => {
  let exercise = {};

  for (let n = 0, length = exerciseDefinition.length; n < length; n++) {
    const item = exerciseDefinition[n];
    if (item.id === exerciseId) {
      exercise = cloneDeep(item);
      break;
    }
  }
  return exercise;
};

export const dealSavingData = (
  data,
  zoneData,
  exerciseDefinition,
  sportConfig,
  defaultUnit,
  currentCriticalPower,
  { globalGradeSystemVal } = {}
) => {
  const info = cloneDeep(data);
  const sportName = Definition.sportCategoryName[info.sportType];
  const newExercises = [];
  let idCount = 1;
  const dealExercise = (item, groupId = '') => {
    let result = {
      isDefaultAdd: 0
    };
    // item.access 修复训练课程 导入, 用户自定义数据
    if (['strength'].includes(sportName)) {
      if (info.access === 1) {
        result = item.originExercise;
      } else {
        result = getExerciseByIdFromDefinition(item.originId, exerciseDefinition);
      }
    } else {
      result = getExerciseByTypeFromDefinition(exerciseDefinition, Definition.getExerciseTypeInfoByName(item.exerciseTypeName).value);
    }
    // 一些必要的
    result.isGroup = false;
    result.groupId = groupId;
    result.originId = result.originId || result.id;
    result.id = idCount++;
    result.sets = item.sets;

    // 目标相关
    result.targetType = 0;
    result.targetValue = 0;

    const targetTypeName = item.targetTypeName;
    const targetTypeCount = item.targetCount[targetTypeName];

    if (targetTypeCount) {
      const targetValue = targetTypeCount.value || 0;

      const targetInfo = Definition.getTargetTypeByName(targetTypeName);
      result.targetType = targetInfo.value;
      result.targetDisplayUnit = Definition.getTargetUnitTypeByName(targetTypeCount.unit);
      if (targetTypeName === 'distance') {
        result.targetValue = distanceToM(targetTypeCount.unit, targetValue);
        result.targetValue = result.targetValue * 100;
      } else if (targetTypeName === 'cumulativeClimb') {
        result.targetValue = Number(mathjsUnit(targetValue, targetTypeCount.unit).toNumber('cm').toFixed(0));
      } else {
        result.targetValue = targetValue;
      }
    }

    // 训练强度
    result.hrType = 0;
    result.isIntensityPercent = item.isIntensityPercent || false;
    result.intensityType = 0;
    result.intensityCustom = 0;
    result.intensityValue = 0;
    result.intensityValueExtend = 0;
    result.intensityMultiplier = 0;
    result.intensityPercent = 0;
    result.intensityPercentExtend = 0;

    const intensityRangeKey = 'range';
    const intensityRatioRangeKey = 'ratioRange';
    const intensityTypeName = item.intensityTypeName;
    const intensityCount = item.intensityCount[intensityTypeName];
    const intensityTypeConfig = sportConfig[item.exerciseTypeName].intensity.typeConfig[item.intensityTypeName];
    //当使用等价配速的时候，训练的pbVersion定义为3
    if (intensityTypeConfig && intensityTypeConfig.pbVersion && intensityTypeConfig.pbVersion > info.pbVersion) {
      info.pbVersion = intensityTypeConfig.pbVersion;
    }
    // 目标类型为心率恢复时，没有强度
    if (targetTypeName !== 'heartRateRecovery' && intensityCount) {
      const intensityRate = intensityCount[intensityRangeKey];
      const intensityRatioRate = intensityCount[intensityRatioRangeKey];

      result.intensityType = Definition.getIntensityTypeByName(intensityTypeConfig.type).value;
      // 强度单位
      result.intensityDisplayUnit = Definition.getIntensityUnitTypeByName(intensityCount.unit);

      if (intensityTypeConfig.type === 'weight') {
        (() => {
          if (!intensityCount.type) {
            result.intensityValue = weightToG(intensityCount.unit, intensityCount.value);
          } else {
            result.intensityValue = '';
            result.intensityCustom = intensityCount.type;
          }
        })();
      } else if (intensityTypeConfig.type === 'heart') {
        (() => {
          const multiplier = 1;
          const hrTypeName = intensityTypeConfig.hrType;
          const isRHr = hrTypeName === 'rhr';

          // 心率类型需要的数据
          result.intensityType = Definition.getIntensityTypeByName(intensityTypeConfig.type).value;
          result.hrType = getHrTypeByHrName(hrTypeName);
          result.intensityCustom = intensityCount.type || 0;

          // 获取出所选区间
          const zone = getIntensityZoneByType(
            {
              exerciseTypeName: item.exerciseTypeName,
              intensityTypeName,
              zoneType: intensityCount.type,
              unit: intensityCount.unit
            },
            sportConfig
          );
          if (intensityCount.type && zone) {
            result.intensityValue = zone.range[0] * multiplier;
            result.intensityValueExtend = zone.range[1] * multiplier;
            result.intensityPercent = zone.ratioRange[0];
            result.intensityPercentExtend = zone.ratioRange[1];
          } else {
            if (result.isIntensityPercent) {
              // 以百分比为准
              // 设置左右百分比
              result.intensityPercent = Math.round(intensityRatioRate[0]);
              result.intensityPercentExtend = Math.round(intensityRatioRate[1]);

              // 设置左右数据
              if (isRHr) {
                result.intensityValue = countRHr(zoneData.rhr, zoneData.maxHr, result.intensityPercent);

                result.intensityValueExtend = countRHr(zoneData.rhr, zoneData.maxHr, result.intensityPercentExtend);
              } else {
                result.intensityValue = Math.round(((zoneData[hrTypeName] * result.intensityPercent) / 100) * multiplier);
                result.intensityValueExtend = Math.round(((zoneData[hrTypeName] * result.intensityPercentExtend) / 100) * multiplier);
              }
            } else {
              // 以绝对值为准
              // 设置左右数据
              result.intensityValue = Math.round(intensityRate[0] * multiplier);
              result.intensityValueExtend = Math.round(intensityRate[1] * multiplier);

              if (isRHr) {
                result.intensityPercent = countRHrRatio(zoneData.rhr, zoneData.maxHr, intensityRate[0]);
                result.intensityPercentExtend = countRHrRatio(zoneData.rhr, zoneData.maxHr, intensityRate[1]);
              } else {
                // 设置左右百分比
                result.intensityPercent = Math.round((intensityRate[0] / zoneData[hrTypeName]) * 100);
                result.intensityPercentExtend = Math.round((intensityRate[1] / zoneData[hrTypeName]) * 100);
              }
            }

            // // 设置左右数据
            // result.intensityValue = Math.round(
            //   intensityRate[0] * multiplier
            // )
            // result.intensityValueExtend = Math.round(
            //   intensityRate[1] * multiplier
            // )
            // // 设置左右百分比
            // result.intensityPercent = Math.round(intensityRatioRate[0])
            // result.intensityPercentExtend = Math.round(
            //   intensityRatioRate[1]
            // )
          }
        })();
      } else if (['pace', 'adjustedPace'].includes(intensityTypeConfig.type)) {
        (() => {
          // 获取出所选区间
          const zone = getIntensityZoneByType(
            {
              exerciseTypeName: item.exerciseTypeName,
              intensityTypeName,
              zoneType: intensityCount.type,
              unit: intensityCount.unit
            },
            sportConfig
          );
          result.intensityMultiplier = 1000;
          result.intensityCustom = intensityCount.type || 0;
          if (intensityCount.type && zone) {
            result.intensityValue = zone.range[0];
            result.intensityValueExtend = zone.range[1];
            result.intensityPercent = zone.ratioRange[0];
            result.intensityPercentExtend = zone.ratioRange[1];
          } else {
            const ltsp = zoneData.ltsp;

            if (result.isIntensityPercent) {
              // 以百分比为准
              // 设置左右百分比
              result.intensityPercent = Math.round(intensityRatioRate[0]);
              result.intensityPercentExtend = Math.round(intensityRatioRate[1]);

              // 设置左右数据
              result.intensityValue = (ltsp / result.intensityPercent) * 100;
              result.intensityValueExtend = (ltsp / result.intensityPercentExtend) * 100;
            } else {
              // 以绝对值为准
              // 单位换算,设置左右数据
              result.intensityValue = paceToSKm(intensityCount.unit, intensityRate[0], 6);
              result.intensityValueExtend = paceToSKm(intensityCount.unit, intensityRate[1], 6);

              // 设置左右百分比
              result.intensityPercent = Math.round((ltsp / result.intensityValue) * 100);
              result.intensityPercentExtend = Math.round((ltsp / result.intensityValueExtend) * 100);
            }
          }

          result.intensityValue = Math.round(result.intensityValue * result.intensityMultiplier);
          result.intensityValueExtend = Math.round(result.intensityValueExtend * result.intensityMultiplier);

          // 确保左值小右值大
          if (result.intensityValue > result.intensityValueExtend) {
            const a = result.intensityValue;
            result.intensityValue = result.intensityValueExtend;
            result.intensityValueExtend = a;
          }

          if (result.intensityPercent > result.intensityPercentExtend) {
            const a = result.intensityPercent;
            result.intensityPercent = result.intensityPercentExtend;
            result.intensityPercentExtend = a;
          }
        })();
      } else if (intensityTypeConfig.type === 'speed') {
        (() => {
          const multiplier = 100;

          result.intensityValue = speedToKmh(intensityCount.unit, intensityRate[0], 6);
          result.intensityValueExtend = speedToKmh(intensityCount.unit, intensityRate[1], 6);

          result.intensityValue = Math.round(result.intensityValue * multiplier);
          result.intensityValueExtend = Math.round(result.intensityValueExtend * multiplier);
        })();
      } else if (intensityTypeConfig.type === 'swimmingStyle') {
        (() => {
          result.intensityValue = intensityCount.type;
        })();
      } else if (intensityTypeConfig.type === 'power') {
        (() => {
          const multiplier = 1;
          result.intensityCustom = 0;
          // 2024年2月，骑行类型下功率不能选择下拉选项
          if (currentCriticalPower > 0 && intensityCount.type && info.sportType !== 2) {
            result.intensityCustom = intensityCount.type || 0;
          }

          result.intensityValue = Math.round(intensityRate[0] * multiplier);
          result.intensityValueExtend = Math.round(intensityRate[1] * multiplier);
        })();
      } else if (intensityTypeConfig.type === 'ftp') {
        (() => {
          const multiplier = 1;
          result.intensityCustom = intensityCount.type || 0;

          // 获取出所选区间
          const zone = getIntensityZoneByType(
            {
              exerciseTypeName: item.exerciseTypeName,
              intensityTypeName,
              zoneType: intensityCount.type,
              unit: intensityCount.unit
            },
            sportConfig
          );
          if (intensityCount.type && zone) {
            result.intensityValue = zone.range[0] * multiplier;
            result.intensityValueExtend = zone.range[1] * multiplier;
            result.intensityPercent = zone.ratioRange[0];
            result.intensityPercentExtend = zone.ratioRange[1];
          } else {
            // 以百分比为准
            // 设置左右百分比
            result.intensityPercent = Math.round(intensityRatioRate[0]);
            result.intensityPercentExtend = Math.round(intensityRatioRate[1]);

            result.intensityValue = Math.round(((zoneData.ftp * result.intensityPercent) / 100) * multiplier);
            result.intensityValueExtend = Math.round(((zoneData.ftp * result.intensityPercentExtend) / 100) * multiplier);
          }
          // console.log(`🔔 result`, result);
        })();
      } else if (intensityTypeConfig.type === 'cadence') {
        (() => {
          const multiplier = 1;
          result.intensityValue = Math.round(intensityRate[0] * multiplier);
          result.intensityValueExtend = Math.round(intensityRate[1] * multiplier);
        })();
      } else if (intensityTypeConfig.type === 'gradeSystem') {
        (() => {
          result.gradeSystem = intensityCount.type;
          const [levelType, level] = intensityCount.hardLevelValue.split('-').map((str) => parseInt(str, 10));
          // 视攀等级偏移
          if (levelType === 1) {
            result.onsightGradeOffset = level;
          } else {
            // 选的是难度等级,这里要为0
            result.onsightGradeOffset = 0;
            result.intensityValue = level;
          }
        })();
      }

      // 强度的百分比需要乘1000
      if (!isNoValue(result.intensityPercent)) {
        result.intensityPercent = result.intensityPercent * 1000;
      }
      if (!isNoValue(result.intensityPercentExtend)) {
        result.intensityPercentExtend = result.intensityPercentExtend * 1000;
      }
    } else {
      result.intensityType = 0;
    }

    // 休息类型
    const restTypeName = item.restTypeName;
    const restTypeCount = item.restCount[restTypeName];
    if (['strength'].includes(sportName) && restTypeCount && restTypeCount.value) {
      const restValue = restTypeCount.value || 0;

      if (restTypeName === 'time') {
        result.restType = Definition.restNameToType(restTypeName);
        result.restValue = restValue;
      }
    } else if (isIndoorClimbOrBoulderingTrainingSportType(info.sportType)) {
      result.restType = 0;
      result.restValue = 0;
    } else {
      result.restType = Definition.restNameToType('noRest');
      result.restValue = 0;
    }

    // 游泳
    if (info.sportType === 3) {
      // 保存包干时间
      result.packageTime = item.packageTime;

      // 5 是包干训练
      if (item.exerciseType === 5) {
        result.subType = 1;
        result.exerciseType = 2;
      }
    }

    // console.log(`🔔 result`, result);
    return result;
  };
  // dealExercise 结束

  info.type = 0;
  info.access = 1;
  // if (!info.exercises) info.exercises = [];
  info.exercises.forEach((item) => {
    if (item.groupId && Array.isArray(item.exerciseList)) {
      const groupId = idCount++;
      // 分组也作为了一个exercise数据
      const { originExercise = {} } = item;
      const { programId, sortNo, sportType, targetType, targetValue, access, exerciseType, name, overview } = originExercise;
      newExercises.push({
        access: access || 0,
        defaultOrder: 0,
        exerciseType: exerciseType || 0,
        id: groupId,
        intensityCustom: 0,
        intensityMultiplier: 0,
        intensityType: 0,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: true,
        name: name || '',
        originId: '',
        overview: overview || '',
        programId: programId || '',
        restType: 0,
        restValue: 30,
        sets: item.sets,
        sortNo: sortNo || 0,
        sourceId: '0',
        sourceUrl: '',
        sportType: sportType || 0,
        subType: 0,
        targetType: targetType || '',
        targetValue: targetValue || 0,
        videoUrl: ''
      });
      for (let n = 0, length = item.exerciseList.length; n < length; n++) {
        newExercises.push(dealExercise(item.exerciseList[n], groupId));
        // newExercises.push(dealExercise(item.exerciseList[n], item.groupId))
      }
    } else {
      newExercises.push(dealExercise(item));
    }
  });
  info.exercises = newExercises;

  const appStore = useAppStore();
  const randomThumbnail = appStore.getRandomThumbnail(30);
  info.sourceId = info.sourceId || randomThumbnail.sourceId || '';
  info.sourceUrl = info.sourceUrl || randomThumbnail.url || '';
  info.unit = info.unit || defaultUnit;

  // 组合需要加上全局强度设置
  // 强度值类型，0：自定义，1：绝对值，2：百分比
  if (info.fastIntensityTypeName && info.fastIntensityTypeName !== 'custom') {
    const intensityTypeConfig = sportConfig.train.intensity.typeConfig[info.fastIntensityTypeName];

    const globalIntensityType = Definition.intensityNameToType(intensityTypeConfig.type);
    const globalHrType = getHrTypeByHrName(intensityTypeConfig.hrType) || 0;

    info.referExercise = {
      intensityType: globalIntensityType,
      hrType: globalHrType,
      valueType: intensityTypeConfig.isIntensityPercent ? 2 : 1
    };
  } else {
    info.referExercise = {
      intensityType: 0,
      hrType: 0,
      valueType: 0
    };
  }
  // 室内攀岩、抱石有全局难度系统设置
  if (isIndoorClimbOrBoulderingTrainingSportType(info.sportType) && globalGradeSystemVal !== 'custom') {
    info.referExercise.gradeSystem = globalGradeSystemVal;
  }

  // 有恢复区的 pbVersion 设置为 5，提示旧版本app不支持【恢复区】升级用
  info.exercises.some((result) => {
    if ([6, 7].includes(result.intensityCustom)) {
      info.pbVersion = 5;
      return true;
    }
  });

  // 如果训练内容带%FTP的，pbVersion赋值为6
  info.exercises.some((result) => {
    // 强度类型 9 为 ftp
    if (result.intensityType === 9) {
      info.pbVersion = 6;
      return true;
    }
  });

  if (info.sportType === 3) {
    // 添加包含泳姿添加分解动作、包干训练的训练课程，pbVersion应该是8
    info.exercises.some((result) => {
      if (
        // 泳姿添加分解动作
        (result.intensityType === 5 && result.intensityValue === 6) ||
        // 包干训练
        result.exerciseType === 5
      ) {
        info.pbVersion = 8;
        return true;
      }
    });
  }

  return info;
};
